module.exports = __webpack_public_path__ + "media/images/pic/teachers/krzysztof-walaszek-cd3c114d6c30c87a6bd2e043e524a5fe.png";